
define('ldsh!modules/estimate_contacts/item/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>EstimateContacts</h1>\n<dl>\n\n</dl>';

}
return __p
};});

